import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import AccessControl from "../molecules/AccessControl";

interface ActionButton {
  icon?: string;
  alt: string;
  className?: string;
  onClick: (rowIndex: number) => void;
}

interface CustomTableProps {
  columns: string[];
  rows: Array<Record<string, any>>;
  actionButtons?: ActionButton[];
  trainingUrl?: boolean;
  permission?: string;
}
// CustomTable renders a table with dynamic columns, rows, and
//  optional action buttons for each row, allowing user interaction like clicking buttons

const CustomTable: React.FC<CustomTableProps> = ({
  columns,
  rows,
  actionButtons,
  trainingUrl,
  permission,
}) => {
  console.log("permission:", permission);
  return (
    <div>
      <table className="table">
        <thead className="TableHeader">
          <tr>
            {columns.map((column, index) => (
              <th className="p-3" key={index}>
                {column}
              </th>
            ))}
            {actionButtons && actionButtons.length > 0 && (
              <th className="p-3">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => {
                const key = Object.keys(row).find(
                  (k) =>
                    k.toLowerCase() === column?.toLowerCase().replace(/ /g, "")
                );
                return (
                  <td key={colIndex} className="p-3">
                    {key ? row[key] : ""}
                  </td>
                );
              })}
              {actionButtons && actionButtons.length > 0 && (
                <td className="p-3">
                  <div>
                    {actionButtons.map(
                      (button, buttonIndex) =>
                        permission && (
                          <AccessControl
                            requiredPermissions={[
                              {
                                permission: permission,
                                types:
                                  permission === "Crew_finetuning"
                                    ? ["read"]
                                    : ["delete"],
                              },
                            ]}
                            renderNoAccess={<></>}
                          >
                            <button
                             
                              className={
                                trainingUrl ? undefined : "btn SaveBtn"
                              }
                              key={buttonIndex}
                              onClick={() => button.onClick(rowIndex)}
                              {...(button.icon && { title: "Delete", "data-bs-toggle": "tooltip" })}
                            >
                              {button.icon ? (
                                <img src={button.icon} alt={button.alt} />
                              ) : (
                                button.alt
                              )}
                            </button>
                          </AccessControl>
                        )
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CustomTable;
